<div class="container-fluid lh-container-fluid">
  <div class="row">
    <div class="col-12 col-sm-7 col-md-6 col-lg-5">
      <lh-login></lh-login>
      <label class="center-block text-center">{{ 'OR' | translate }}</label>
      <lh-register></lh-register>
    </div>
  </div>
</div>
